export const getTerminology = ({ code, prefix, suffix }: { code: string; prefix?: string; suffix?: string }) => {
    const mapping = sessionStorage.getItem('ws.terminology');
    const data = mapping ? JSON.parse(mapping) : null;
    const str = data.find((item: any) => item.code === code)?.name || 'Scene';
    return `${prefix || ''} ${str} ${suffix || ''}`.trim();
};
